import { Card, Col } from 'reactstrap'
import CommonProfileHead from '../Common/CommonProfileHead'
import { P } from '../../../../../AbstractElements'
import { useAuth } from '../../../../../hooks/useAuth'
import { Badge } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const ProfileDetails = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Información adicional del usuario
  const getAdditionalInfo = () => {
    if (!user) return t("No hay información adicional disponible.");
    
    const info = [];
    if (user.country) {
      info.push(`${t("País")}: ${user.country.name || user.country.code}`);
    }
    if (user.language) {
      const languageMap: { [key: string]: string } = {
        "ES": "Español",
        "EN": "English",
        "FR": "Français",
        "PT": "Português",
      };
      info.push(`${t("Idioma preferido")}: ${languageMap[user.language] || user.language}`);
    }
    if (user.created_at) {
      const createdDate = new Date(user.created_at);
      const locale = user?.language === 'EN' ? 'en-US' : 'es-ES';
      info.push(`${t("Miembro desde")}: ${createdDate.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' })}`);
    }
    
    return info.length > 0 
      ? info.join('. ') + '.'
      : t("No hay información adicional disponible.");
  };

  return (
    <Col sm="12">
      <Card>
        <div className="profile-img-style">
          <CommonProfileHead activeTime={t("Información del perfil")}/>
          <hr />
          <div className="mb-3">
            {user?.role && (
              <Badge color="primary" className="me-2 mb-2">
                {user.role.name}
              </Badge>
            )}
            {user?.active !== undefined && (
              <Badge color={user.active ? "success" : "secondary"} className="me-2 mb-2">
                {user.active ? t("Activo") : t("Inactivo")}
              </Badge>
            )}
            {user?.is_superadmin && (
              <Badge color="warning" className="me-2 mb-2">
                {t("Super Administrador")}
              </Badge>
            )}
          </div>
          <P className="block-ellipsis mb-4">{getAdditionalInfo()}</P>
          {user?.type_cases && user.type_cases.length > 0 && (
            <div className="mt-3">
              <strong>{t("Tipos de casos")}:</strong>
              <div className="mt-2">
                {user.type_cases.map((caseType, index) => {
                  // Mapear códigos de caso a nombres descriptivos
                  const caseTypeMap: { [key: string]: string } = {
                    "PF": t("Petición familiar"),
                    "PC": t("Procesos consulares"),
                    "AE": t("Ajuste de estatus"),
                    "PE": t("Perdones"),
                    "PT": t("Permiso de trabajo"),
                    "CT": t("Corte"),
                    "VI": t("Visa"),
                    "IG": t("Inmigración general")
                  };
                  
                  const caseCode = caseType.case || '';
                  const caseName = caseTypeMap[caseCode] || caseCode || `${t("Caso")} ${caseType.id || index}`;
                  
                  return (
                    <Badge key={index} color="info" className="me-2 mb-2">
                      {caseName}
                    </Badge>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </Card>
    </Col>
  )
}

export default ProfileDetails